import React from 'react';
import { Space, Table, Tag } from 'antd';
import userDateFormatter from '../../../services/formatters/userDateFormatter';

const CustomerOfferList = ({tableData}) => {
    const statusTags = {
        POSITIVE: <Tag color='green'>OLUMLU</Tag>,
        NEGATIVE: <Tag color='red'>OLUMSUZ</Tag>,
        WAITING: <Tag color='cyan'>BEKLIYOR</Tag>
    }

    const columns = [
        {
            title: 'Teklif No',
            dataIndex: 'bn',
            key: 'bn',
        },
        {
            title: 'Durum',
            dataIndex: 'b',
            key: 'b',
            render: (t) => statusTags[t]
        },
        {
            title: 'Tarih',
            dataIndex: 'd',
            key: 'd',
            render: (t) => userDateFormatter(t)
        },
        {
            title: 'Toplam Fiyat',
            dataIndex: 't',
            key: 't',
            render: (t, r) => (<Space>
                {r.cl.map((i, idx) => (<p key={`${idx}-${i.c}`} className='font-bold'>{i.c}: <span>{new Intl.NumberFormat().format(i.pit)}</span></p>)) }
            </Space>)
        }
    ];

    const onRowHandler = (record) => {
        if(record.id) {
            window.open(
                `${window.location.origin}/landing/offer/detail/${record.id}`,
                '_blank'
            )
        }
    };

    const rowKeys = (record) => record.id;

    return(
        <>
            <Table rowKey={rowKeys} dataSource={tableData} columns={columns} size={'middle'} onRow={(record, rowIndex) => ({onDoubleClick: () => onRowHandler(record, rowIndex)})}/>
        </>
    )
};

export default CustomerOfferList;